import React from "react";
import { Jumbotron, Container, Row, Col } from "react-bootstrap";
import { useMediaQuery } from "react-responsive";

function About() {
  const isDesktopOrLaptop = useMediaQuery({ minDeviceWidth: 1366 });
  const isBigScreen = useMediaQuery({ minDeviceWidth: 1824 });
  const isTabletOrMobile = useMediaQuery({ maxWidth: 1224 });
  const isTabletOrMobileDevice = useMediaQuery({ maxDeviceWidth: 1224 });
  const isPortrait = useMediaQuery({ orientation: "portrait" });
  const isRetina = useMediaQuery({ minResolution: "2dppx" });

  const isMobileDevice = useMediaQuery({ maxDeviceWidth: 767 });
  const isTabletDevice = useMediaQuery({
    minDeviceWidth: 768,
    maxDeviceWidth: 1224,
  });

  return (
    <div>
      {isDesktopOrLaptop && (
        <Jumbotron fluid style={{ backgroundColor: "#E72129" }}>
          {/* <h1 style={{ marginTop: -20, color: "#FFFFFF" }}>This is About Page</h1> */}
          <Container>
            <Row className="row row-cols-1 row-cols-md-3 g-4">
              <Col>
                <h1
                  style={{
                    color: "#FFFFFF",
                    fontWeight: "bold",
                  }}
                >
                  Function A
                </h1>
                <p style={{ color: "white" }}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing.
                </p>
              </Col>
              <Col>
                <h1 style={{ color: "#FFFFFF", fontWeight: "bold" }}>
                  Function B
                </h1>
                <p style={{ color: "white" }}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing.
                </p>
              </Col>
              <Col>
                <h1 style={{ color: "#FFFFFF", fontWeight: "bold" }}>
                  Function C
                </h1>
                <p style={{ color: "white" }}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing.
                </p>
              </Col>
            </Row>
          </Container>
        </Jumbotron>
      )}
      {isTabletDevice && (
        <Jumbotron fluid style={{ backgroundColor: "#E72129" }}>
          {/* <h1 style={{ marginTop: -20, color: "#FFFFFF" }}>This is About Page</h1> */}
          <Container>
            <Row className="row row-cols-1 row-cols-md-3 g-4">
              <Col>
                <h1 style={{ color: "#FFFFFF", fontWeight: "bold" }}>
                  Function A
                </h1>
                <p style={{ color: "white" }}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing.
                </p>
              </Col>
              <Col>
                <h1 style={{ color: "#FFFFFF", fontWeight: "bold" }}>
                  Function B
                </h1>
                <p style={{ color: "white" }}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing.
                </p>
              </Col>
              <Col>
                <h1 style={{ color: "#FFFFFF", fontWeight: "bold" }}>
                  Function C
                </h1>
                <p style={{ color: "white" }}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing.
                </p>
              </Col>
            </Row>
          </Container>
        </Jumbotron>
      )}
      {isMobileDevice && (
        <Jumbotron fluid style={{ backgroundColor: "#E72129" }}>
          {/* <h1 style={{ marginTop: -20, color: "#FFFFFF" }}>This is About Page</h1> */}
          <Container>
            <Row className="row row-cols-1 row-cols-md-3 g-4">
              <Col>
                <h2 style={{ color: "#FFFFFF", fontWeight: "bold" }}>
                  Function A
                </h2>
                <p style={{ color: "white" }}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing.
                </p>
              </Col>
              <Col>
                <h2 style={{ color: "#FFFFFF", fontWeight: "bold" }}>
                  Function B
                </h2>
                <p style={{ color: "white" }}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing.
                </p>
              </Col>
              <Col>
                <h2 style={{ color: "#FFFFFF", fontWeight: "bold" }}>
                  Function C
                </h2>
                <p style={{ color: "white" }}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing.
                </p>
              </Col>
            </Row>
          </Container>
        </Jumbotron>
      )}
    </div>
  );
}

export default About;
